<template>
    <div id="app">
        <main role="main" class="main-cont">
            <!--body-->
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <!--<div v-if="loading">
                                <img class="progressLoader" />
                            </div>-->
                            <div v-if="loading" class="spinner__icon spinner__icon--xxlarge spinner_position">
                            </div>
                            <h1 class="mb-4 appName">Corporte Income Tax</h1>
                            <div class="panelDiv">
                                <div class="col-sm-12 mb-4">
                                    <div class="col-sm-6 col-md-6">
                                        <h2 class="mb-3 subHeader">Select Client Name</h2>
                                    </div>
                                    <div class="col-sm-10 col-md-11">
                                        <select v-model="selectedClient" aria-label="Client name dropdown" title="Please select the client name" name="clientName" v-validate="'required'" class="form-control col-sm-6 selectarrow" :class="{'is-invalid':errors.has('clientName')}">
                                            <option value="" selected disabled>Please select Client Name</option>
                                            <option v-for="clt in clientmap" :key="clt.id" v-bind:value="{ id: clt.id, text: clt.clientName }">{{ clt.clientName }}</option>
                                        </select>
                                        <div>
                                            <span v-show="errors.has('clientName')"
                                                  class="text-danger">Please select the Client Name</span>
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="col-sm-6 col-md-6">
                                        <h2 class="mb-3 subHeader">Base Fiscal</h2>
                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group" style="border: 1px solid grey; border-radius: 5px;margin-right: 18px;">
                                            <input type="number" aria-label="Base fiscal input textbox" title="Please enter the base fiscal value" v-model="baseFiscal" class="form-control" style="background-color:#e7e7ea" name="baseFiscal" v-validate="'required|max:50'" v-on:keypress="isNumber($event)" :class="{'is-invalid':errors.has('baseFiscal')}">
                                        </div>
                                        <div>
                                            <span v-show="errors.has('baseFiscal')"
                                                  class="text-danger">Please enter the Base Fiscal</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panelDiv">
                                <h2 class="mb-3 subHeader">Upload Section <i class="fa fa-close" aria-hidden="true" style="color:black"></i></h2>
                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                <div class="row col-sm-12 mb-4">
                                    <div class="col-sm-12 col-md-12">
                                        <label>Upload Zip (.zip)</label>
                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                        <div class="row">
                                            <div class="file-upload col-sm-6 col-md-6 col-6">
                                                <div class="file-select col-sm-12 col-md-12 col-12">
                                                    <div class="file-select-name col-sm-7 col-md-7 col-7" id="noFile">
                                                        {{UploadedFile}}
                                                    </div>
                                                    <input class="col-sm-12 col-md-12 col-12" aria-label="File selector to open file browser" title="Click to select file" type="file" name="chooseFile" v-validate="`required|size:${fileSize}`" id="CITFile" ref="CITFile" v-on:change="handleCITFile()" accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed">
                                                    <button class="btn file-select-button col-sm-5 col-md-5 col-5" style="margin-right:-14px;" id="fileName" aria-label="Browse button to open file browser" title="Click browse to select file">Browse</button>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 col-md-3">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-12">
                                        <span v-show="errors.has('chooseFile')"
                                              class="text-danger">Please Upload the Valid file</span>
                                    </div>
                                </div>
                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                <div class="row col-sm-12 mb-4">
                                    <div class="col-sm-12 col-md-12">
                                        <button class="btn btn-secondary mr-4" aria-label="Upload button" title="Click upload to start calculation" v-on:click="Fetch">Upload</button>
                                    </div>
                                </div>
                                <div class="col-sm-3 col-md-5"></div>
                                <div class="col-sm-9 col-md-7 dp-inline-fx"> </div>
                                <div v-if="renderDiv">
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row">
                                        <div class="row col-sm-12">
                                            <div class="col-sm-8">
                                                <h2 class="mb-3 subHeader">Codigo Accounts</h2>
                                            </div>
                                            <div class="col-sm-4">
                                            </div>
                                        </div>
                                        <div v-for="(accountdata, index) in workbookarray.accountDetails" v-bind:key="index.id" class="row col-sm-12">
                                            <div class="col-sm-2">
                                                <label style="font-weight:bold;color:lightblack;" class="mb-3 col-form-label">{{accountdata.accountType}}</label>
                                            </div>
                                            <div class="col-sm-5">
                                                <div class="form-group" style="border: 1px solid grey; border-radius: 5px;margin-right: 18px;">
                                                    <input aria-label="Enter the accounts value" title="Accounts value" v-model='accountdata.accounts' class="form-control" style="background-color:#e7e7ea" name="accounts" v-validate="'required'">
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row">
                                        <div v-for="(workbookdata, index) in workbookarray.fileDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                            <div class="row col-sm-12">
                                                <div class="col-sm-8">
                                                    <label style="font-weight:bold;color:lightblack;" class="mb-3 col-form-label">{{workbookdata.fileName}}</label>
                                                </div>
                                                <div class="col-sm-4">
                                                </div>
                                            </div>
                                            <div class="floating-label d-flex flex-column flex-md-row"></div>
                                            <div class="floating-label d-flex flex-column flex-md-row"></div>
                                            <div class="floating-label d-flex flex-column flex-md-row"></div>
                                            <div class="floating-label d-flex flex-column flex-md-row"></div>
                                            <div v-bind:id="'box' + workbooksheetdata.id" v-for="(workbooksheetdata, index) in workbookdata.sheetDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                                <div class="col-sm-12 row">
                                                    <div class="col-sm-3">
                                                        <label style="font-weight:bold;color:lightblack;" class="mb-3 col-form-label">{{workbooksheetdata.labelName}}</label>
                                                    </div>
                                                    <div class="col-sm-6">
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <button class="btn" title="Include/Exclude button" aria-label="Click to include/exclude the worksheet" v-bind:class="{excludebtntype:btnexclude}" v-bind:id="'exclude' + workbooksheetdata.id" v-on:click="handleExcludeEvent($event,workbooksheetdata.id)">Exclude</button>
                                                    </div>
                                                </div>
                                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                <div class="col-sm-12 row">
                                                    <div class="col-sm-6">
                                                        <select class="form-control col-sm-7 selectarrow " v-model="workbooksheetdata.sheetName" title="Worksheet option dropdown" aria-label="Select the respective worksheet from the dropdown">
                                                            <option v-for="(worksheets, value) in sheetNames" v-bind:key="value">
                                                                {{ worksheets.sheetname }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <br>
                                                <br>
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-9 col-md-7 dp-inline-fx">
                                                        <div class="col-sm-6  pl-0">
                                                            <div class="mt-2 new-form">
                                                                <div class="floating-label d-flex flex-column flex-md-row">
                                                                    <input v-model="workbooksheetdata.columnStart"
                                                                           class="floating-input"
                                                                           type="number"
                                                                           title="Column start value"
                                                                           aria-label="Enter the column start value, use cursor to increase or decrease the value"
                                                                           placeholder=" "
                                                                           v-on:keypress="isNumber($event)"
                                                                           v-validate="'required|colParameter'"
                                                                           name="colStart">
                                                                    <span class="highlight"></span>
                                                                    <label>Start Column</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6  pl-0">
                                                            <div class="mt-2 new-form">
                                                                <div class="floating-label d-flex flex-column flex-md-row">
                                                                    <input v-model='workbooksheetdata.columnEnd'
                                                                           class="floating-input"
                                                                           type="number"
                                                                           title="Column end value"
                                                                           aria-label="Enter the column end value, use cursor to increase or decrease the value"
                                                                           placeholder=" "
                                                                           v-on:keypress="isNumber($event)"
                                                                           v-validate="'required|colParameter'"
                                                                           name="colEnd">
                                                                    <span class="highlight"></span>
                                                                    <label>End Column</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-9 col-md-7 dp-inline-fx">
                                                        <div class="col-sm-6  pl-0">
                                                            <div class="mt-2 new-form">
                                                                <div class="floating-label d-flex flex-column flex-md-row">
                                                                    <input v-model='workbooksheetdata.rowStart'
                                                                           class="floating-input"
                                                                           type="number"
                                                                           title="Row start value"
                                                                           aria-label="Enter the start end value, use cursor to increase or decrease the value"
                                                                           placeholder=" "
                                                                           v-on:keypress="isNumber($event)"
                                                                           v-validate="'required|rowParameter'"
                                                                           name="rowStart">
                                                                    <span class="highlight"></span>
                                                                    <label>Start Row</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6  pl-0">
                                                            <div class="mt-2 new-form">
                                                                <div class="floating-label d-flex flex-column flex-md-row">
                                                                    <input v-model='workbooksheetdata.rowEnd'
                                                                           class="floating-input"
                                                                           title="Row end value"
                                                                           aria-label="Enter the row end value, use cursor to increase or decrease the value"
                                                                           type="number"
                                                                           placeholder=" "
                                                                           v-on:keypress="isNumber($event)"
                                                                           v-validate="'required|rowParameter'"
                                                                           name="rowEnd">
                                                                    <span class="highlight"></span>
                                                                    <label>End Row</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <span v-if="errors.has('rowEnd' ) || errors.has('rowStart') || errors.has('colStart') || errors.has('colEnd')" class="text-danger">Please enter the mandatory parameters</span>
                                    </div>

                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row">
                                        <div class="col">
                                            <button class="btn btn-primary mr-4" v-on:click="Save" aria-label="Click generate to generate the worksheet" title="Worksheet generation button" v-bind:disabled="generateDisabled">Generate</button>
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div v-if="showreconciliationsuccess" class="col-sm-6 alert" style="margin-left:20px;word-wrap: break-word;box-shadow: 0 0 1rem 0 rgba(0,0,0,.2);">
                                        <font-awesome-icon :icon="['fas', 'check-circle']" class="icon check" style="width:16px;height:16px;color:#168736;" />
                                        &nbsp;&nbsp;Workpaper Generated Successfully
                                        <div style="padding-top: 10px;">
                                            <a :href="fileName" class="alert-link" style="cursor: pointer;color:#155cb4;">
                                                <font-awesome-icon :icon="['fas', 'download']" class="icon download" style="width:16px;height:16px;" />
                                                &nbsp;&nbsp;Click here to download
                                            </a>
                                        </div>
                                    </div>
                                    <div v-if="showreconciliationwarning" class="col-sm-6 alert" style="margin-left:20px;box-shadow:  0 0 1rem 0 rgba(0,0,0,.2);">
                                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="icon exclamationCircle" style="width:16px;height:16px;color:#b9251c;" />
                                        &nbsp;&nbsp; Fail to process the request, Please check & verify below points:
                                        <ul>
                                            <li>Select client.</li>
                                            <li>Upload the files for the selected client.</li>
                                            <li>Data range provided is correct.</li>
                                            <li>Refer user manual for more help.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2 ">
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import Navbar from '../Navbar/Navbar';
    import CommonService from '../../services/SharedService/common.service.js';
    import VeeValidate from "vee-validate";
    import AppValidations from "../../services/validation.js";
    import { EnvironmentConfig } from '../../services/constants';
    import Algorithm from "../../services/Algorithm.js";
    export default {

        name: 'CITHome',
        data() {

            return {
                selectedBank: '',
                selectedClient: '',
                bankandclientmap: [],
                bankarrayresult: [],
                clientarrayresult: [],
                BankclientmappingID: '',
                bankname: '',
                clientname: '',
                UploadedFile: "Choose file (Max file size 100 MB)",
                renderDiv: false,
                CITFile: '',
                btnexclude: true,
                workbookarray: [],
                cloneworkbookarray: [],
                sheetNames: [],
                isBoxed: true,
                baseFiscal: '',
                clientmap: [],
                showreconciliationsuccess: false,
                showreconciliationwarning: false,
                fileName: '',
                loading: false,
                fileSize: EnvironmentConfig._FileSize,
                generateDisabled: false
            }
        },
        components: {
            'Navigation': Navbar,
            VeeValidate
        },
        created: function () {
            localStorage.setItem('route', this.$route.name);
            this.loadClientNames();
        },
        mixins: [CommonService, AppValidations, Algorithm],
        methods: {
            loadClientNames() {
                this.ClientMapping("cit").then(response => {
                    if (response) {
                        this.clientmap = response.data;
                    }
                });
            },
            handleCITFile() {
                this.CITFile = null;
                this.CITFile = this.$refs.CITFile.files[0];
                this.UploadedFile = this.CITFile.name;

            },

            Fetch() {
                this.$validator.validate().then(valid => {
                    function deepCopy(oldObj) {
                        var newObj = oldObj;
                        if (oldObj && typeof oldObj === 'object') {
                            newObj = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
                            for (var i in oldObj) {
                                newObj[i] = deepCopy(oldObj[i]);
                            }
                        }
                        return newObj;
                    }
                    if (valid) {
                        this.loading = true;
                        const formData = new FormData();
                        formData.append("fileCit", this.CITFile);
                        formData.append("FileType", "cit");
                        formData.append("TableName", "");
                        formData.append("FirstName", localStorage.getItem('firstName'));
                        formData.append("LastName", localStorage.getItem('lastName'));
                        formData.append("UserName", localStorage.getItem('userName'));
                         formData.append("ClientId", this.selectedClient.id);
                        //this.ImportUploadedFile(formData).then(Response => {
                        this.ImportZipFolder(formData).then(Response => {
                            if (Response) {
                                this.loading = false;
                                this.workbookarray = [];
                                this.cloneworkbookarray = [];
                                this.workbookarray = Response.data;
                                this.workbookarray.fileDetails[0].sheetDetails[0].labelName = "Income Tax";
                                this.workbookarray.fileDetails[0].sheetDetails[1].labelName = "Social Contribution";
                                this.workbookarray.fileDetails[0].sheetDetails[2].labelName = "Trial Balance";
                                this.workbookarray.fileDetails[0].sheetDetails[3].labelName = "Deferred Tax";
                                this.renderDiv = true;
                                this.cloneworkbookarray = deepCopy(this.workbookarray);
                                this.sheetNames = [];
                                for (var key_fileDetails in this.cloneworkbookarray["fileDetails"]) {
                                    for (var key_sheetDetails in this.cloneworkbookarray["fileDetails"][key_fileDetails]["sheetDetails"]) {
                                        this.sheetNames.push(
                                            {
                                                sheetname: this.cloneworkbookarray["fileDetails"][key_fileDetails]["sheetDetails"][key_sheetDetails]["sheetName"],

                                            }

                                        );
                                    }
                                }
                            } else {
                                this.loading = false;
                            }
                        });
                    }
                });
            },
            Save() {
                this.showreconciliationwarning = false;
                this.showreconciliationsuccess = false;
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.loading = true;
                        this.generateDisabled = true;
                        this.cloneworkbookarray.AppName = "cit";
                        this.cloneworkbookarray.BaseFiscal = this.baseFiscal;
                        this.cloneworkbookarray.MappingId = this.selectedClient.id;
                        this.cloneworkbookarray.Clientname = this.selectedClient.text;
                        this.cloneworkbookarray.Username = localStorage.getItem('userName');
                        this.cloneworkbookarray.UserID = localStorage.getItem('userId');
                        this.cloneworkbookarray.FirstName = localStorage.getItem('firstName');
                        this.cloneworkbookarray.LastName = localStorage.getItem('lastName');
                        for (var key_cloneaccountDetails in this.cloneworkbookarray["accountDetails"]) {
                            var cloneAccountType = this.cloneworkbookarray["accountDetails"][key_cloneaccountDetails]["accountType"];
                            for (var key_originalaccountDetails in this.workbookarray["accountDetails"]) {
                                var originalAccountType = this.workbookarray["accountDetails"][key_originalaccountDetails]["accountType"];
                                if (cloneAccountType == originalAccountType) {
                                    this.cloneworkbookarray["accountDetails"][key_cloneaccountDetails]["accounts"] = this.workbookarray.accountDetails[key_originalaccountDetails]["accounts"];
                                }
                            }
                        }
                        for (var key_clonesheetDetails in this.cloneworkbookarray["fileDetails"][0]["sheetDetails"]) {
                            var cloneLabelName = this.cloneworkbookarray["fileDetails"][0]["sheetDetails"][key_clonesheetDetails]["labelName"];
                            for (var key_originalsheetDetails in this.workbookarray["fileDetails"][0]["sheetDetails"]) {
                                var originalLabelName = this.workbookarray["fileDetails"][0]["sheetDetails"][key_originalsheetDetails]["labelName"];
                                if (cloneLabelName == originalLabelName) {
                                    this.cloneworkbookarray.fileDetails[0].sheetDetails[key_clonesheetDetails].rowStart = this.workbookarray.fileDetails[0].sheetDetails[key_originalsheetDetails].rowStart;
                                    this.cloneworkbookarray.fileDetails[0].sheetDetails[key_clonesheetDetails].columnStart = this.workbookarray.fileDetails[0].sheetDetails[key_originalsheetDetails].columnStart;
                                    this.cloneworkbookarray.fileDetails[0].sheetDetails[key_clonesheetDetails].rowEnd = this.workbookarray.fileDetails[0].sheetDetails[key_originalsheetDetails].rowEnd;
                                    this.cloneworkbookarray.fileDetails[0].sheetDetails[key_clonesheetDetails].columnEnd = this.workbookarray.fileDetails[0].sheetDetails[key_originalsheetDetails].columnEnd;
                                    this.cloneworkbookarray.fileDetails[0].sheetDetails[key_clonesheetDetails].sheetName = this.workbookarray.fileDetails[0].sheetDetails[key_originalsheetDetails].sheetName;
                                }
                            }
                        }
                        var JsonArray = JSON.stringify(this.cloneworkbookarray); // converting array object into json
                        JsonArray = "[" + JsonArray + "]";
                        this.SaveDetails(JsonArray).then(Response => {
                            if (Response) {
                                var reconciliationfile = Response.data != undefined ? Response.data : "Internal server error";
                                if (reconciliationfile == "Internal server error" || reconciliationfile == "500" || reconciliationfile == "[object Object]" || Response.isAxiosError) {
                                    this.loading = false;
                                    this.generateDisabled = false;
                                    this.showreconciliationwarning = true;
                                    this.showreconciliationsuccess = false;
                                }
                                else {
                                    this.loading = false;
                                    this.generateDisabled = false;
                                    this.fileName = reconciliationfile;
                                    this.showreconciliationwarning = false;
                                    this.showreconciliationsuccess = true;
                                }
                            }
                        });
                    }
                });
            },
            Download() {
                this.DownloadFile(this.fileName);
            },

            handleExcludeEvent(e, workbookId) {
                if (document.getElementById('exclude' + workbookId).classList.contains('excludebtntype')) {
                    document.getElementById('exclude' + workbookId).classList.remove('excludebtntype');
                    document.getElementById('exclude' + workbookId).classList.add('excludebtntype1');
                    document.getElementById('exclude' + workbookId).textContent = "Include";
                    document.getElementById('box' + workbookId).style.backgroundColor = "lightgrey";
                    //removing row from cloned array
                    let i = this.cloneworkbookarray["fileDetails"][0]["sheetDetails"].map(item => item["id"]).indexOf(workbookId);
                    this.cloneworkbookarray["fileDetails"][0]["sheetDetails"].splice(i, 1);
                }

                else {
                    document.getElementById('exclude' + workbookId).classList.remove('excludebtntype1');
                    document.getElementById('exclude' + workbookId).classList.add('excludebtntype');
                    document.getElementById('exclude' + workbookId).textContent = "Exclude";
                    document.getElementById('box' + workbookId).style.backgroundColor = "";
                    //adding row back to cloned array
                    var retrievedArray = this.workbookarray["fileDetails"][0]["sheetDetails"].filter(function (el) {
                        return el["id"] == workbookId;
                    });
                    this.cloneworkbookarray["fileDetails"][0]["sheetDetails"].splice(1, 0, ...retrievedArray);
                }
            }
        }
    };
</script>
<style scoped>
    .homeText {
        font-size: 35px;
        color: red;
        text-align: center;
        position: relative;
        top: 30px;
        text-shadow: 2px 2px 2px gray;
    }

    .boxed {
        border: 1px solid rgb(211, 211, 211);
        padding: 10px;
        margin: 10px;
        border-radius: 5px;
    }

    .excludebtntype {
        background-color: #ffe600;
        border-radius: 0 !important;
        box-shadow: none !important;
    }

    .excludebtntype1 {
        background-color: grey;
        border-radius: 0 !important;
        box-shadow: none !important;
    }

    span.remove-file {
        color: red;
        cursor: pointer;
        float: right;
    }

    .vl {
        border-left: 6px solid green;
        height: 500px;
    }

    select {
        /* styling */
        background-color: #e7e7ea;
        border: thin solid grey;
        border-radius: 4px;
        display: inline-block;
        font: inherit;
        line-height: 1.5em;
        padding: 0.5em 3.5em 0.5em 1em;
        /* reset */
        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
    }

        select.selectarrow {
            background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
            background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
            background-size: 5px 5px, 5px 5px, 1px 1.5em;
            background-repeat: no-repeat;
        }

            select.selectarrow:focus {
                background-image: linear-gradient(45deg, green 50%, transparent 50%), linear-gradient(135deg, transparent 50%, green 50%), linear-gradient(to right, #ccc, #ccc);
                background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, calc(100% - 2.5em) 0.5em;
                background-size: 5px 5px, 5px 5px, 1px 1.5em;
                background-repeat: no-repeat;
                border-color: green;
                outline: 0;
            }

        select:-moz-focusring {
            color: transparent;
            text-shadow: 0 0 0 #000;
        }

    .homebody {
        /* background-image: url("../../assets/city.jpg"); */
        background-color: #3333331a;
    }

    .appName {
        font-size: 1.5rem;
    }

    .subHeader {
        font-size: 1.25rem;
    }
</style>